<template>
  <footer class="comp--footer-btn bg-white" :class="{'fixed': fixed}">
    <slot>
      <div class="btn btn-block btn-lg" v-if="color" :style="{'background': color, 'color': fontColor}"
           :class="[(disabled ? 'btn-disabled' : '')]">
        {{text}}
      </div>
      <div class="btn btn-block btn-lg" v-else
           :class="[type ? ('btn-'+ type) : '', (disabled ? 'btn-disabled' : '')]">
        {{text}}
      </div>
    </slot>
  </footer>
</template>

<script>
  /**
   * @props
   * type [string] danger, primary, info, default, warning
   * disabled
   * fixed
   * text
   * color 自定义颜色
   */
  export default {
    name: 'c-footer-btn',
    props: {
      text: {
        type: String,
        default: '确定'
      },
      type: {
        type: String,
        default: 'primary'
      },
      comment: {
        type: Boolean,
        default: false
      },
      commentId: {
        type: [String, Number],
        default: null
      },
      disabled: Boolean,
      fixed: Boolean,
      color: String,
      fontColor: String
    },
    methods: {
      goToComment () {
        this.$router.push({name: 'Comment', query: {id: this.commentId}})
      }
    }
  }
</script>

<style lang="less">
  .comp--footer-btn {
    display: flex;
    padding: 10px;
    bottom: 0;
    right: 0;
    left: 0;
    z-index: 100;
    justify-content: center;
    .btn {
      flex: 3;
      display: block;
    }
    &.fixed {
      position: fixed;
    }
  }

  /*.disabled{*/
  /*pointer-events: auto;*/
  /*.btn{*/
  /*opacity: .4;*/
  /*}*/
  /*}*/
</style>
